import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import "../../css/profile.css";
import Navbar from "../../components/Navbar";
import CandidateOverviewAbout from "../../components/candidateoverview/pagecomponents/CandidateOverviewAbout";
import CandidateOverviewAboutText from "../../components/candidateoverview/pagecomponents/CandidateOverviewAboutText";
import CandidateOverviewSkillsOnly from "../../components/candidateoverview/pagecomponents/CandidateOverviewSkillsOnly";
import CandidateOverviewExperience from "../../components/candidateoverview/pagecomponents/CandidateOverviewExperience";
import CandidateOverviewEducationCourses from "../../components/candidateoverview/pagecomponents/CandidateOverviewEducationCourses";
import "./../../css/candidateProfile.css";
import CandidateOverviewSpecialityOnly from "../../components/candidateoverview/pagecomponents/CandidateOverviewSpecialityOnly";
import AboutMeModal from "../../components/candidateoverview/pagecomponents/AboutMeModal";
import SummaryModal from "../../components/candidateoverview/pagecomponents/SummaryModal";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { useGetEducationsMutation, useGetProfileDataFromDBMutation } from "../../store/profileSlice";
import { setEducations, setIndustries, setProfileData } from "../../reducers/userReducer";
import { useGetIndustriesMutation } from "../../store/appSlice";
import Loader from "../../components/Loader";
import CandidateIndustry from "../../components/candidateoverview/pagecomponents/CandidateIndustry";

function CandidateProfile() {
  const [getProfileDataFromDB] =
    useGetProfileDataFromDBMutation();

  const [isEditAboutMeModal, setEditAboutMeModal] = useState(false);
  const [isEditSummaryTextModal, setEditSummaryTextModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const [aboutUser,setAboutUser] = useState('');
  const[videoUrl,setVideoUrl]=useState("")
  const { user } = useAppSelector((state) => state["user"]);
  const dispatch=useAppDispatch()
  const [getIndustries] = useGetIndustriesMutation();
  const [getEducations] = useGetEducationsMutation();



  useEffect(() => {
    getProfileDetailsFromDb();
    getAllIndustriesIds()
    getAllDegrees()

  }, []);

  useEffect(() => {
    setAboutUser(userData?.candidate?.aboutYou??'');
    setVideoUrl(userData?.candidate?.video??'')
    console.log({userData})
  }, [userData]);

  const onEditAboutMe = () => {
    setEditAboutMeModal(true);
  };

  const onEditSummaryText = () => {
    setEditSummaryTextModal(true);
  };

  const onSaveSummary=(data)=>{
    setAboutUser(data?.aboutData)
    setVideoUrl(data?.videoUrl)
  }

  const getProfileDetailsFromDb = async () => {
    const filterDetails = encodeURIComponent(`
    
{
    "fields": {
        "id": true,
        "title": true,
        "profilePicture": true,
        "town": true,
        "aboutYou": true,
        "video": true,
        "yearsOfExperience": true,
        "industryIds": true,
        "professionIds": true,
        "skillIds": true,
        "userId": true,
        "country": true,
        "city": true,
        "location":true
    },
    
    "include": [{
            "relation": "candidateWorkExperiences"
            
        },
        {
            "relation": "candidateEducations"
        },
        {
            "relation": "candidateCertificates"
        },
        {
            "relation": "candidatePortfolios"
              
        },
        {
            "relation": "candidateJobCriteria"
              
        },
        {
            "relation": "user"
        }
    ]
}
`);

    let payload = {
      filterDetails,
      param: user?.id ?? "",
    };
    console.log({ payload });
    getProfileDataFromDB(payload)
      .unwrap()
      .then((incomingData) => {
        console.log({ incomingDataProfile:incomingData });
        setUserData(incomingData);
        dispatch(setProfileData(incomingData));
        setIsLoading(false)

      })
      .catch((err) => {
        console.log("error");

        console.log(err);
      });
  };


  const getAllIndustriesIds = async () => {
    const filterDetails = encodeURIComponent(`
  {
    "where" : { 
      "isActive": true
    }
  }
      `);
  
    let data = {
      filterDetails,
    };
  
    getIndustries(data)
      .unwrap()
      .then((payload) => {
  console.log({industrue:payload})
  dispatch(setIndustries(payload));
})
      .catch((err) => {});
  };


  const getAllDegrees=()=>{
  
    getEducations()
    .unwrap()
    .then((incomingData) => {
dispatch(setEducations(incomingData));

    })
    .catch((err) => {
      console.log("error");

      console.log(err);
    });
  } 

  return (
    <div className="profile__container">
      <Navbar />
      <div
        style={{
          width: "60%",
          alignSelf: "center", 
          marginLeft: "10px",
          marginTop: "90px",
        }}
      >
        <div className="r2ms-c2-candidate-overview-main__candidate-about">

{isLoading?<Loader loader={isLoading}/>:( 
<>
          <CandidateOverviewAbout 
          getUpdatedData={getProfileDetailsFromDb}
          data={{city:userData?.candidate?.city??'',country:userData?.candidate?.country??'',
           title:userData?.candidate?.title??'',yearsOfExp:userData?.candidate?.yearsOfExperience??0,
            name:userData?.candidate?.user?.name??'',profilePicture:userData?.candidate?.profilePicture??'',
            openForRemote:userData?.candidate?.candidateJobCriteria?.isRemote??false, jobTypes:userData?.candidate?.candidateJobCriteria?.jobType??[],industries:userData?.industries??[]
            }} onEdit={onEditAboutMe}  /> 

          {/* <CandidateOverviewVideo  /> */}

          <CandidateOverviewAboutText data={{aboutUser,videoUrl}} onEdit={onEditSummaryText} industries={userData?.industries??[]}/>
          <div style={{  borderBottom: '1px solid rgba(238, 239, 243, 0.95)',marginBottom:'20px',marginTop:'20px'}}/>

          <CandidateIndustry getUpdatedData={getProfileDetailsFromDb} industry={userData?.industries??[]} />
          <div style={{borderBottom: '1px solid rgba(238, 239, 243, 0.95)',marginBottom:'20px',marginTop:'20px'}}/>

          <CandidateOverviewSpecialityOnly data={userData?.professions??[]}/>
          <div style={{borderBottom: '1px solid rgba(238, 239, 243, 0.95)',marginBottom:'20px',marginTop:'20px'}}/>

          <CandidateOverviewSkillsOnly data={userData?.skills??[]}/>
          <div style={{borderBottom: '1px solid rgba(238, 239, 243, 0.95)',marginBottom:'20px',marginTop:'20px'}}/>

          <CandidateOverviewExperience getUpdatedData={getProfileDetailsFromDb} data={userData?.candidate?.candidateWorkExperiences??[]}/>
          <div style={{borderBottom: '1px solid rgba(238, 239, 243, 0.95)',marginBottom:'20px'}}/>

          <CandidateOverviewEducationCourses getUpdatedData={getProfileDetailsFromDb} educationData={userData?.candidate?.candidateEducations??[]}
           coursesData={userData?.candidate?.candidateCertificates??[]}
           
           />
           </>
           )} 
        </div>
      </div> 

 
      {isEditAboutMeModal && (
        <AboutMeModal
          data={{}}
          isVisible={isEditAboutMeModal}
          onClose={() => setEditAboutMeModal(!isEditAboutMeModal)}
          getUpdatedData={getProfileDetailsFromDb}
        />
      )}

    {/* about you summary text */}
      {isEditSummaryTextModal && (
        <SummaryModal 
          data={{aboutData:aboutUser,videoUrl:videoUrl}}
          onEditSave={onSaveSummary}
          isVisible={isEditSummaryTextModal}
          onClose={() => setEditSummaryTextModal(!isEditSummaryTextModal)}

        />
      )}
    </div>
  );
}

export default CandidateProfile;
